module.exports = __webpack_public_path__ + "img/people.30b5134c.svg";